import { createGenericDictionary } from "../helpers/createDictionary";

export enum APARTMENT_TYPE {
  FLAT = 0,
  APARTMENT = 1,
  COMMERCIAL = 2,
  PARKING = 3,
  STORAGE = 4,
  CONSTRUCTION = 5,
}

export const UnknownType = {
  id:    -1,
  name:  "Объект",
  about: "об объекте",
};

const list = [
  {
    id:    APARTMENT_TYPE.FLAT,
    name:  "Квартира",
    about: "о квартире",
  },
  {
    id:    APARTMENT_TYPE.APARTMENT,
    name:  "Апартаменты",
    about: "об апартаментах",
  },
  {
    id:    APARTMENT_TYPE.COMMERCIAL,
    name:  "Помещение",
    about: "о помещении",
  },
  {
    id:    APARTMENT_TYPE.PARKING,
    name:  "Паркинг",
    about: "о паркинге",
  },
  {
    id:    APARTMENT_TYPE.STORAGE,
    name:  "Кладовка",
    about: "о кладовке",
  },
  {
    id:    APARTMENT_TYPE.CONSTRUCTION,
    name:  "Строение",
    about: "о строении",
  },
];

export default createGenericDictionary({ list, formatLabel: (item) => item.name })
